import { offset, size } from '@floating-ui/react'

export function coverReferenceMiddleware() {
	return [
		offset(({ rects }) => {
			return (
				((rects.reference.height + rects.floating.height) / 2) * -1
			)
		}),
		size({
			apply({ rects, elements }) {
				Object.assign(elements.floating.style, {
					width: `${rects.reference.width}px`,
					height: `${rects.reference.height}px`,
				})
			},
		}),
	]
}
